import { render, staticRenderFns } from "./UserWatchlist.vue?vue&type=template&id=44bf5bb4&"
import script from "./UserWatchlist.vue?vue&type=script&lang=js&"
export * from "./UserWatchlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports